import { useSelector } from "react-redux";

import { TAppState } from "store/root.store";

export const useAltCustodySelector = () => useSelector((state: TAppState) => state.altCustodyReducer);
